import React from 'react';
import { classNames, noop } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as NavigationUpIcon } from '../../../../resources/assets/components/DLS_NavigationUp.svg';
function InformationBarExpander(props) {
    const { expanded = false, onClick = noop } = props;
    const expanderClasses = classNames({
        'c-information-bar__expander': true,
        'is-expanded': expanded,
    });
    return (React.createElement(NavigationUpIcon, { className: expanderClasses, onClick: onClick }));
}
export { InformationBarExpander, };
//# sourceMappingURL=information-bar-expander.js.map